import Vue from "vue";
import createAuth0Client from "@auth0/auth0-spa-js";
const useClasslink = process.env.VUE_APP_ORG == 'isp';
//const tenantValidation = process.env.VUE_APP_ISP_TENANT.split(".");

//const crypto = require('crypto');
//let nonce = crypto.randomBytes(16).toString('base64');

//import axios from 'axios'
/** Define a default action to perform after authentication */
const DEFAULT_REDIRECT_CALLBACK = () =>

 
  window.history.replaceState({}, document.title, window.location.pathname);

let instance;

/** Returns the current instance of the SDK */
export const getInstance = () => instance;

/** Creates an instance of the Auth0 SDK. If one has already been created, it returns that instance */
export const useAuth0 = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirectUri = window.location.origin,
  ...options
}) => {
  if (instance) return instance;

  // The 'instance' is simply a Vue object
  instance = new Vue({
    data() {
      return {
        loading: true,
        isAuthenticated: false,
        user: {},
        userId: null,
        roles: [],
        auth0Client: null,
        auth0Management: null,
        popupOpen: false,
        error: null,
        isAdmin: false,
        isAuthor: false,
        isDataManager: false,
        isLocalAdmin: false,
        isTester: false
      };
    },
    methods: {
   
      /** Authenticates the user using a popup window */
      async loginWithPopup(o) {
        debugger;
        this.popupOpen = true;

        try {
          await this.auth0Client.loginWithPopup(o);
        } catch (e) {
          // eslint-disable-next-line
          console.error(e);
        } finally {
          this.popupOpen = false;
        }

        this.user = await this.auth0Client.getUser();
        this.isAuthenticated = true;
      },
      /** Handles the callback when logging in using a redirect */
      async handleRedirectCallback() {
        debugger;
        this.loading = true;
        try {
          await this.auth0Client.handleRedirectCallback();
          this.user = await this.auth0Client.getUser();
         /* if(useClasslink){
            var tenant = this.user.profileData.classLink_tenant_id_string; 
            if(!tenantValidation.includes(tenant)){
              alert("Access not enabled");
              this.logout();
            }
          }
            */
          this.isAuthenticated = true;
        } catch (e) {
          this.error = e;
        } finally {
          this.loading = false;
        }
      },
      /** Authenticates the user using the redirect method */
      loginWithRedirect(o) {
        //TODO -- change this org Id to ISP
        debugger;
      //  if(useClasslink){

         // o.prompt=nonce;
       // }
        debugger;
        if (window.location.search.includes("invitation=")){
          debugger;
          console.log('Invitation flow')
          var arr1 = window.location.href.split("invitation=");
          var arr2 = arr1[1].split("&organization=");
          var arr3 = arr2[1].split("&organization_name=");
          var invite = arr2[0];
          var org = arr3[0];
          var orgName = arr3[1];
          o.invitation = invite;
          o.organization = org;
          o.organization_name = orgName;
          console.log(o);
          //return this.auth0Client.loginWithPopup(o);
          return this.auth0Client.loginWithRedirect(o);
        }
        
        return this.auth0Client.loginWithRedirect(o);
      },
       /* loginWithRedirectClassLink(o) {
        //TODO -- change this org Id to ISP
    
      
          o.prompt=nonce;
        if (window.location.search.includes("invitation=")){
          debugger;
          console.log('Invitation flow')
          var arr1 = window.location.href.split("invitation=");
          var arr2 = arr1[1].split("&organization=");
          var arr3 = arr2[1].split("&organization_name=");
          var invite = arr2[0];
          var org = arr3[0];
          var orgName = arr3[1];
          o.invitation = invite;
          o.organization = org;
          o.organization_name = orgName;
          console.log(o);
          //return this.auth0Client.loginWithPopup(o);
          return this.auth0Client.loginWithRedirect(o);
        }
        
        return this.auth0Client.loginWithRedirect(o);
      },
      */
      /** Returns all the claims present in the ID token */
      getIdTokenClaims(o) {
        return this.auth0Client.getIdTokenClaims(o);
      },

      /** Returns the access token. If the token is invalid or missing, a new one is retrieved */
      getTokenSilently(o) {
        return this.auth0Client.getTokenSilently(o);
      },
      /** Gets the access token using a popup window */
      getTokenWithPopup(o) {
        return this.auth0Client.getTokenWithPopup(o);
      },
      /** Logs the user out and removes their session on the authorization server */
      logout(o) {
        return this.auth0Client.logout(o);
      },
      getRoles(o) {
        if (this.isAuthenticated) {
          return this.getIdTokenClaims(o).then((x) => {
            if (x && x["https://smartrubric.com/roles"]) {
              return x["https://smartrubric.com/roles"];
            }
            return [];
          });
        }
      },
   
      getUserId(o) {
        if (this.isAuthenticated) {
          return this.getIdTokenClaims(o).then((x) => {
            if (x && x["https://smartrubric.com/individual_id"]) {
              return x["https://smartrubric.com/individual_id"];
            }
            return null;
          });
        }
      },
   
      getUsersByEmail(e){
        return this.auth0Management.getUsersByEmail(e);
      }
    },
    /** Use this lifecycle method to instantiate the SDK client */
    async created() {
      // Create a new instance of the SDK client using members of the given options object
      debugger;
      if(useClasslink){
      this.auth0Client = await createAuth0Client({
        domain: options.domain,
        client_id: options.clientId,
        audience: options.audience,
        redirect_uri: redirectUri,
        organization: options.authOrg  
      });
      }
      else{
      this.auth0Client = await createAuth0Client({
        domain: options.domain,
        client_id: options.clientId,
        audience: options.audience,
        redirect_uri: redirectUri,
        organization: options.authOrg        
      });
      }



      try {
        // If the user is returning to the app after authentication..
        if (
          window.location.search.includes("code=") &&
          window.location.search.includes("state=")
        ) {
          // handle the redirect and retrieve tokens
          debugger;
          const { appState } = await this.auth0Client.handleRedirectCallback();

          // Notify subscribers that the redirect callback has happened, passing the appState
          // (useful for retrieving any pre-authentication state)
          onRedirectCallback(appState);
        }
      } catch (e) {
        this.error = e;
      } finally {
        // Initialize our internal authentication state
        this.isAuthenticated = await this.auth0Client.isAuthenticated();
        this.user = await this.auth0Client.getUser();
        this.userId = await this.getUserId();
        this.roles = await this.getRoles();
        if (this.roles) {
          if(this.roles.includes("Administrator")){
            this.isAdmin = true;
          }
          if(this.roles.includes("DataManager")){
            this.isDataManager = true;
          }
          if(this.roles.includes("Author")){
            this.isAuthor = true;
          }
          if(this.roles.includes("LocalAdmin")){
            this.isLocalAdmin = true;
          }
          if(this.roles.includes("Tester")){
            this.isTester = true;
          }
        }
        this.loading = false;
      }
    },
  });

  return instance;
};

// Create a simple Vue plugin to expose the wrapper object throughout the application
export const Auth0Plugin = {
  install(Vue, options) {
    Vue.prototype.$auth = useAuth0(options);
  },
};
